import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/services_/tech-support_/montclair")({
  beforeLoad: () => {
    throw redirect({ to: "/tech-support-montclair-ca", statusCode: 301 });
  },
});
